import { PPSSState, SwitchState } from '@types';

export const INITIAL_STATE: PPSSState = {
  data: {
    tableRows: [],
    filteredTableRows: [],
    asOfDates: {
      navAsOfDate: '',
      performanceAsOfDateMonthly: '',
      performanceAsOfDateMonthlyStd: '',
      performanceAsOfDateQuarterly: '',
      performanceAsOfDateQuarterlyStd: '',
    },
  },
  config: {
    tabs: {
      showPerformance: true,
      showYield: false,
      showRatings: false,
      showFundIdentifiers: false,
    },
    performanceViewOptions: [],
    performanceView: null,
    periodEnd: null,
    calcType: null,
    currentTable: 'PERFORMANCE',
    showPerformanceCurrency: false,
    showFavoritesOnlySwitch: false,
    favoriteOnlySwitchState: SwitchState.OFF,
    showDownloadDataButton: false,
  },
  siteConfig: null,
};
